import { render, staticRenderFns } from "./MainNavigationV2.vue?vue&type=template&id=819fc57e&scoped=true&"
import script from "./MainNavigationV2.vue?vue&type=script&lang=js&"
export * from "./MainNavigationV2.vue?vue&type=script&lang=js&"
import style0 from "./MainNavigationV2.vue?vue&type=style&index=0&id=819fc57e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "819fc57e",
  null
  
)

export default component.exports